import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "speach",
  "use": "speach-usage",
  "viewBox": "0 0 22.3 22.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.3 22.3\" id=\"speach\"><path d=\"M11.1 22.3c-.8 0-10.5-.2-10.6-.2h-.6V11.4C0 5.3 4.8.2 10.8 0c6.3-.2 11.5 4.9 11.5 11.1 0 6.2-5 11.2-11.2 11.2zM1.1 21c2.1 0 9.3.2 10 .2 5.5 0 10-4.5 10-10 0-5.6-4.7-10.2-10.4-10-5.2.1-9.6 4.7-9.6 10.2V21z\" /><path d=\"M5.3 12.7h1.4v-1.4H5.3v1.4zM10.5 12.7h1.4v-1.4h-1.4v1.4zM15.7 11.3v1.4h1.4v-1.4h-1.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol